import { Template } from './Template';

const getColors = (colors: string[]): HTMLElement[] => {
    const colorElemets: HTMLElement[] = [];
    colors.forEach((c) => {
        colorElemets.push(Template.createElement(
            'div', {
                class: 'datasheet__table__colorball',
                style: `background-color: ${c}`,
            }, [],
        ));
    });

    return colorElemets;
};

export const nodeTeaser = (
    title: string,
    comercialName: string,
    url: string,
    colors: string[],
    cover: string,
    type: string,
    rowMode = false,
): HTMLElement => {
    const colorsTemplate = getColors(colors);

    return Template.createElement(
        'div', { class: ['product-teaser'] }, Template.createElement(
            'div', {
                class: [
                    'product-teaser__container',
                    ...(rowMode ? ['product-teaser__container--row-mode'] : []),
                ],
            }, [
                Template.createElement(
                    'a', { href: url }, [
                        Template.createElement('div', { class: 'product-teaser__preview' }, [
                            Template.createElement('div', { class: 'product-teaser__preview__colors' }, colorsTemplate),
                            Template.createElement('img', { src: cover }, []),
                        ]),
                    ],
                ),
                Template.createElement(
                    'div', { class: 'product-teaser__desc' }, [
                        Template.createElement(
                            'div', { class: 'product-teaser__desc__title' }, [
                                Template.createElement(
                                    'h4', {}, type,
                                ),
                                Template.createElement(
                                    'a', { href: url }, title,
                                ),
                            ],
                        ),
                        Template.createElement(
                            'div', { class: 'product-teaser__desc__content' }, Template.createElement(
                                'div', {}, comercialName,
                            ),
                        ),
                    ],
                ),
            ],
        ),
    );
};
